import { Route } from '@angular/router';
import { WellProdIndexPage } from 'app/modules/well-production-status/pages/index.page';

export const wProdStatusDashboardRoutes: Route[] = [
    {
        path: 'well-prod-status',
        children: [],
    },
];

export const wProdStatusManagementRoutes: Route[] = [
    {
        path: 'well-prod-status',
        children: [
            {
                path: '',
                component: WellProdIndexPage,
            },
        ],
    },
];

export const wProdStatusConfigurationRoutes: Route[] = [
    {
        path: 'well-prod-status',
        children: [],
    },
];
